import { ICity } from "../pages/SearchUsers/utils/interfaces";
import { SearchMembers } from "../typings/member";
import { SearchUsersProps } from "../typings/searchUsers";
import { TagProps } from "../typings/tag";

//Action Types
export const SET_CITY_SEARCH = "SET_CITY_SEARCH";
export const SET_USERNAME_SEARCH = "SET_USERNAME_SEARCH";
export const SET_TAGS_POOL_SEARCH = "SET_TAGS_POOL_SEARCH";
export const TOGGLE_TAG_SELECTION = "TOGGLE_TAG_SELECTION";
export const SET_SEARCH_MEMBERS_RESULTS = "SET_SEARCH_MEMBERS_RESULTS";
export const RESET_USERS_SEARCH_DATA = "RESET_USERS_SEARCH_DATA";

//Action creators
export const setCitySearch = (data: ICity | undefined) => ({
  type: SET_CITY_SEARCH,
  data,
});

export const setUsernameSearch = (data: string) => ({
  type: SET_USERNAME_SEARCH,
  data,
});

export const toggleTagSelection = (data: number) => ({
  type: TOGGLE_TAG_SELECTION,
  data,
});

export const setTagsPoolSearch = (data: TagProps[]) => ({
  type: SET_TAGS_POOL_SEARCH,
  data,
});

//TODO: Add new action function for adding the result of the searched members
export const setSearchMembersResults = (data: SearchMembers[]) => ({
  type: SET_SEARCH_MEMBERS_RESULTS,
  data,
});

export const resetSearchData = () => ({
  type: RESET_USERS_SEARCH_DATA,
});

// Initial State
const initialState: SearchUsersProps = {
  city: {
    id: -1,
    cityName: "",
  },
  username: "",
  tagsPool: [],
  searchResults: [],
};

//Reducer
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case SET_CITY_SEARCH:
      return { ...state, city: action.data };
    case SET_USERNAME_SEARCH:
      return { ...state, username: action.data };
    case SET_TAGS_POOL_SEARCH:
      return { ...state, tagsPool: action.data };
    case TOGGLE_TAG_SELECTION:
      const updatedTagsPool = state.tagsPool.map((item) =>
        item.value === action.data
          ? { ...item, isSelected: !item.isSelected }
          : item
      );
      return { ...state, tagsPool: updatedTagsPool };

    case SET_SEARCH_MEMBERS_RESULTS:
      return { ...state, searchResults: action.data };

    case RESET_USERS_SEARCH_DATA:
      return { ...initialState };

    default:
      return state;
  }
}
